import React from 'react';

import Pagination from 'Components/Pagination';

import Row from './Row';
import TableHeader from './TableHeader';
import Select, { selectType } from 'Components/Select';
import Button, { buttonColor } from 'Components/Button';

export default class ComponentList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activePage: 1,
      selectedRowsCount: 10,
      sortedBy: 'id',
      sortAsc: -1,
      filter: {},
      searchString: '',
    };
  }

  _handleActivePageChange = activePage => {
    this.setState({ activePage });
  };

  _sortList = (a, b) => {
    const { sortedBy, sortAsc } = this.state;

    switch (sortedBy) {
      case 'id':
        return +a.id > +b.id ? sortAsc : -sortAsc;
      default:
        return (a[sortedBy] || ' ').toString().toLowerCase().replace(/\s+/g, ' ') >
          (b[sortedBy] || ' ').toString().toLowerCase().replace(/\s+/g, ' ')
          ? sortAsc
          : -sortAsc;
    }
  };

  handleSort = sortedBy => () => {
    this.setState(prevState => ({
      sortedBy,
      sortAsc: prevState.sortedBy === sortedBy ? -prevState.sortAsc : 1,
      activePage: 1,
    }));
  };

  handleSearchStringInput = value => {
    this.setState({ searchString: value, activePage: 1 });
  };

  handleSelectFilter = filterFieldName => filterElement => {
    let { filter } = this.state;
    const newFilterFieldValue = filterElement.value !== undefined ? filterElement.value : filterElement;

    if (newFilterFieldValue === 'All') delete filter[filterFieldName];
    else filter[filterFieldName] = newFilterFieldValue;

    this.setState({ filter: filter, activePage: 1 });
  };

  _getList = () => {
    const { activePage, selectedRowsCount, sortedBy } = this.state;
    const { familyComponents, user, selectComponentForDeletion, deleteSingleComponent } = this.props;

    let resultList = [...familyComponents.sort(this._sortList)];

    const resultLength = resultList.length;
    const sliceFrom = (activePage - 1) * selectedRowsCount;
    const sliceTo = +selectedRowsCount ? activePage * selectedRowsCount : resultList.length;

    resultList = resultList.slice(sliceFrom, sliceTo).map(component => {
      return (
        <Row
          key={component.id}
          user={user}
          sortedBy={sortedBy}
          component={component}
          selectComponentForDeletion={selectComponentForDeletion}
          deleteSingleComponent={deleteSingleComponent}
        />
      );
    });

    return {
      resultList,
      resultLength,
    };
  };

  render() {
    const {
      components,
      familyComponents,
      selectComponentForAdd,
      togleAllComponentsForAdd,
      addComponents,
      deleteComponents,
      deleteAllComponents,
      componentsRequestInProcess,
    } = this.props;
    const { activePage, selectedRowsCount, sortedBy, sortAsc } = this.state;
    const { resultList, resultLength } = this._getList();
    const selectedToDeleteAmount = familyComponents.filter(component => component.checked).length;

    return (
      <section className='scene_section'>
        <header>Component List</header>

        <div className='__main-alert-label _margin_bottom_0 _line-height_normal'>
          You are allowed to add components once to only one Component Family. If you want to add the component to a
          different Component Family, you have to delete it from the family it belongs.
        </div>

        <div className='_width_pc_100 _flex _flex_nowrap'>
          <div className='_width_pc_100'>
            <div className='_flex _jc_end'></div>
            <Select
              type={selectType.primarySmall}
              multiSelect
              withCheckBoxes
              selectionList={components}
              itemNameIndicator={['id', 'description']}
              handleSelect={selectComponentForAdd}
              placeholder='Search/Select Component by ID or Name'
              mainWrapperClassName='_width_pc_100'
              dropDownClassName='_max_height_201'
              selectAll={togleAllComponentsForAdd(true)}
              unselectAll={togleAllComponentsForAdd(false)}
              isLoading={!components.length && componentsRequestInProcess}
              disabledInfoText='Component is already added to another component family'
            />
          </div>

          <Button
            label='+ Add Selected'
            buttonClassName='button__small button__small_square _margin_top_22 _margin_left_10'
            color={buttonColor.gray}
            onClick={addComponents}
          />
        </div>

        <div className='__delimiter_horisontal'></div>

        <div className='_width_pc_100 _flex'>
          <Button
            label='Remove all'
            buttonClassName='button__small button__small_square'
            color={buttonColor.red}
            onClick={deleteAllComponents}
          />
          {!!selectedToDeleteAmount && (
            <Button
              label={`Remove  Selected (${selectedToDeleteAmount})`}
              buttonClassName='button__small button__small_square _margin_left_10 _width_110'
              color={buttonColor.gray}
              onClick={deleteComponents}
            />
          )}
        </div>

        <TableHeader
          handleSortClick={this.handleSort}
          order={sortAsc === 1}
          sortedBy={sortedBy}
          familyComponents={familyComponents}
        />

        <div className='list__wrapper'>{resultList}</div>
        {familyComponents.length > 10 && (
          <footer className='list-scene__footer _jc_center'>
            <Pagination
              className='_height_80'
              activePage={activePage}
              handleClick={this._handleActivePageChange}
              allRowsCount={resultLength}
              selectedRowsCount={selectedRowsCount}
            />
          </footer>
        )}
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/ComponentManufacturer/ComponentFamily/New/ComponentList/index.jsx